import { ReactNode } from "react";
import { IntlProvider } from "react-intl";
import { LanguagesIsoEnum } from "@/modules/assessments/types/test.interface";
import { DEFAULT_LOCALE, logIntlError, useLazyLocaleMessages } from "@/i18n";

interface DevelopIntlScopeProps {
  locale: LanguagesIsoEnum;
  children: ReactNode;
}

// Scopes react-intl to the Develop report's chosen display language, so its catalog strings follow the
// language control without flipping the rest of the admin UI. Bundle loading is handled by the shared
// useLazyLocaleMessages hook.
export default function DevelopIntlScope({ locale, children }: DevelopIntlScopeProps) {
  const { locale: activeLocale, messages } = useLazyLocaleMessages(locale);

  return (
    <IntlProvider
      locale={activeLocale}
      defaultLocale={DEFAULT_LOCALE}
      messages={messages}
      onError={(error) => logIntlError(error, { locale: activeLocale, component: "DevelopIntlScope" })}
    >
      {children}
    </IntlProvider>
  );
}
